import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BackIcon, NakedButton } from '@frontend/design-system';
import { useMFAContext } from './mfa-context';

const styles = {
  backButton: css`
    display: flex;
    align-items: center;
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.large};
    gap: ${theme.spacing(1)};
  `,
};

export function MFABackButton() {
  const { t } = useTranslation('account');
  const { prevStep } = useMFAContext((ctx) => ({
    prevStep: ctx.prevStep,
  }));

  return (
    <NakedButton css={styles.backButton} onClick={prevStep}>
      <BackIcon />
      {t('Back')}
    </NakedButton>
  );
}
